import { Box } from '@factorialco/deprecated-design-system'

import PreviewAttachments from '../../../../components/Preview/Attachments'
import PreviewDescription from '../../../../components/Preview/Description'
import PreviewTitle from '../../../../components/Preview/Title'
import { EmployeeInfoPreview } from './EmployeeInfoPreview'
import { IDUploadPreview } from './IDUploadPreview'
import { SocialSecurityUploadPreview } from './SocialSecurityUploadPreview'

const Preview = () => {
  return (
    <Box>
      <PreviewTitle />
      <PreviewDescription />
      <PreviewAttachments />
      <EmployeeInfoPreview />
      <IDUploadPreview />
      <SocialSecurityUploadPreview />
    </Box>
  )
}

export default Preview
